module.exports = __webpack_public_path__ + "static/dog-s-6434440e944ca114657d9ac2288233d4.jpg";